'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var Connection = require('interface-connection').Connection;

var pull = require('pull-stream');

var timeout = require('async/timeout');

var queue = require('async/queue');

var debug = require('debug');

var log = debug('libp2p:swarm:dialer:queue');
/**
 * Queue up the amount of dials to a given peer.
 */

var DialQueue =
/*#__PURE__*/
function () {
  /**
   * Create a new dial queue.
   *
   * @param {number} limit
   * @param {number} dialTimeout
   */
  function DialQueue(limit, dialTimeout) {
    var _this = this;

    _classCallCheck(this, DialQueue);

    this.dialTimeout = dialTimeout;
    this.queue = queue(function (task, cb) {
      _this._doWork(task.transport, task.addr, task.token, cb);
    }, limit);
  }
  /**
   * The actual work done by the queue.
   *
   * @param {SwarmTransport} transport
   * @param {Multiaddr} addr
   * @param {CancelToken} token
   * @param {function(Error, Connection)} callback
   * @returns {void}
   * @private
   */


  _createClass(DialQueue, [{
    key: "_doWork",
    value: function _doWork(transport, addr, token, callback) {
      log('work');

      this._dialWithTimeout(transport, addr, function (err, conn) {
        if (err) {
          log('work:error');
          return callback(null, {
            error: err
          });
        }

        if (token.cancel) {
          log('work:cancel'); // clean up already done dials

          pull(pull.empty(), conn); // TODO: proper cleanup once the connection interface supports it
          // return conn.close(() => callback(new Error('Manual cancel'))

          return callback(null, {
            cancel: true
          });
        } // one is enough


        token.cancel = true;
        log('work:success');
        var proxyConn = new Connection();
        proxyConn.setInnerConn(conn);
        callback(null, {
          multiaddr: addr,
          conn: conn
        });
      });
    }
    /**
     * Dial the given transport, timing out with the set timeout.
     *
     * @param {SwarmTransport} transport
     * @param {Multiaddr} addr
     * @param {function(Error, Connection)} callback
     * @returns {void}
     *
     * @private
     */

  }, {
    key: "_dialWithTimeout",
    value: function _dialWithTimeout(transport, addr, callback) {
      timeout(function (cb) {
        var conn = transport.dial(addr, function (err) {
          if (err) {
            return cb(err);
          }

          cb(null, conn);
        });
      }, this.dialTimeout)(callback);
    }
    /**
     * Add new work to the queue.
     *
     * @param {SwarmTransport} transport
     * @param {Multiaddr} addr
     * @param {CancelToken} token
     * @param {function(Error, Connection)} callback
     * @returns {void}
     */

  }, {
    key: "push",
    value: function push(transport, addr, token, callback) {
      this.queue.push({
        transport: transport,
        addr: addr,
        token: token
      }, callback);
    }
  }]);

  return DialQueue;
}();

module.exports = DialQueue;